import { FetchState } from "../Models/Client/FetchState"
import { useAppState } from "./useReduxState"
import { selectUser } from "../Helpers/Functions/Selectors/auth"
import { useMemo } from "react"
import { Result } from "../Models/Utility/Result"

export function useBackofficeAdmin(): FetchState<boolean> {
    const currentUser = useAppState(selectUser)

    return useMemo(
        () =>
            currentUser === undefined
                ? currentUser
                : Result.ok(currentUser.backofficeAdmin === true),
        [currentUser]
    )
}
